export default __webpack_public_path__ + "static/banner-b6b128c9606631cf8fdbd385bd7a4532.jpg";